import MobileColumnLeft from './components/Left';
import MobileColumnRight from './components/Right';

export const TransactionsMobileColumn = {
	Left: MobileColumnLeft,
	Right: MobileColumnRight,
};
